import { find } from 'lodash';
import { VIEW_LEVELS, ViewLevel } from './view-levels';

export interface ZoomLevelRange {
  name: ViewLevel;
  min?: number;
  max?: number;
}

export const MAP_ZOOM_LEVELS: { [k: string]: ZoomLevelRange } = {
  [VIEW_LEVELS.MARKET]: { name: VIEW_LEVELS.MARKET as ViewLevel, max: 9 },
  [VIEW_LEVELS.PROPERTY]: { name: VIEW_LEVELS.PROPERTY as ViewLevel, min: 10 },
  [VIEW_LEVELS.PROPERTYSEARCH]: { name: VIEW_LEVELS.PROPERTY as ViewLevel, min: 15 }
}

export const resolveZoomLevel = (level: ViewLevel) => MAP_ZOOM_LEVELS[level];
export const resolveView = (zoom: number) => find(MAP_ZOOM_LEVELS, f => {
  const x = (!f.min || zoom >= f.min) && (!f.max || zoom <= f.max)
  console.log('ZOOM', f.min, f.max, f.name, zoom, x)
  return x;
})



// WEBPACK FOOTER //
// ./src/app/main/constants/map-zoom-levels.ts